module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f65cd88bc1b65a135f150a972bc5c3bc.png";